import { bootstrapApplication } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'

Sentry.init({
  dsn: environment.SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
